import { IonCol, IonGrid, IonImg, IonRow } from "@ionic/react";
import React from "react";
import { ReferenceDialogWeb } from "./referenceDialogWeb";

export const TripLoadStop: React.FunctionComponent<any> = (props: any) => {
  const stopDetail = props.stopDetails;

  return (
    <React.Fragment>
      <IonGrid class="trip-load-stop">
        <IonRow>
          <IonCol size="12">
            <IonGrid className="stop-address-grid">
              <IonRow>
                <IonCol size="12">
                  <p className="stop-number-details">{`${(!!props.isOrigin &&
                    "Origin") ||
                    (!!props.isDestination && "Destination") ||
                    "Stop " + props.index}`}</p>
                  <p className="origin_city load-stop-name">
                    {`${stopDetail && stopDetail.city}, ${stopDetail &&
                      stopDetail.state}`}
                  </p>

                  <IonGrid>
                    <IonRow>
                      <IonCol size="auto">
                        {stopDetail && stopDetail.locationName && (
                          <p className="address-location-name">
                            {stopDetail.locationName}
                          </p>
                        )}

                        {stopDetail && stopDetail.addressLine1 && (
                          <p className="address-details">
                            {stopDetail.addressLine1}
                          </p>
                        )}

                        {stopDetail && stopDetail.addressLine2 && (
                          <p className="address-details">
                            {stopDetail.addressLine2}
                          </p>
                        )}

                        <p className="address-details">
                          {stopDetail.city}, {stopDetail.state},{" "}
                          {stopDetail.postalCode}
                        </p>
                      </IonCol>
                      <IonCol size="auto">
                        <IonImg
                          src="./assets/icon/shipment-map-icon.svg"
                          className="shipment-map-icon"
                          onClick={() => {
                            if (props.onShowMap) {
                              props.onShowMap(stopDetail.locationName, {
                                lat: parseFloat(stopDetail.latitude),
                                lng: parseFloat(stopDetail.longitude),
                              });
                            }
                          }}
                        />
                      </IonCol>
                    </IonRow>
                  </IonGrid>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol size="12">
            <ReferenceDialogWeb
              stopDetail={stopDetail}
              carrierId={props.carrierId}
              shipment={props.loadDetails}
            />
          </IonCol>
        </IonRow>
      </IonGrid>
    </React.Fragment>
  );
};
